import { Item } from "../../Models";
import PropTypes from "prop-types";
import React from "react";
import SearchHeaderItem from "./sections/SearchHeaderItem";
import { SearchSelectors } from "../../../../redux/selectors";
import classNames from "classnames";
import { useSelector } from "react-redux";

const SearchPCHeaderSection = ({ trackingInfo }) => {
  const searchSettings = useSelector(SearchSelectors.settings);

  const className = classNames("aChelpLink", "circleIcon");

  const onClick = e => {
    e.preventDefault();
    e.stopPropagation();

    return false;
  };

  const item = new Item({
    termKey: searchSettings.termKey,
    title: searchSettings.title,
    iconKey: searchSettings.iconKey,
    iconURL: searchSettings.iconUrl,
    URL: searchSettings.url
  });

  const searchTrackingInfo = trackingInfo
    ? Object.assign({}, trackingInfo, { dataLabel: "search-button" })
    : {
        dataCategory: "default",
        dataAction: "click",
        dataLabel: "PC - Search",
        dataValue: ""
      };

  return (
    <div id="searchPC">
      <div id="searchSection" data-testid="searchSection">
        <SearchHeaderItem
          item={item}
          className={className}
          automationId="uc-search-button"
          onClick={onClick}
          trackingInfo={searchTrackingInfo}
        ></SearchHeaderItem>
      </div>
    </div>
  );
};

SearchPCHeaderSection.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(SearchPCHeaderSection);
